import { render, staticRenderFns } from "./PromoClients.vue?vue&type=template&id=3ec23ba0&scoped=true&lang=html&"
import script from "./PromoClients.vue?vue&type=script&lang=js&"
export * from "./PromoClients.vue?vue&type=script&lang=js&"
import style0 from "./PromoClients.vue?vue&type=style&index=0&id=3ec23ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec23ba0",
  null
  
)

export default component.exports